import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { useFaturaAtual } from '../core/useFaturaAtual'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { faturaAtendimentosColumns } from './columns/_columns'
import { FaturaAtendimentoList } from '../core/_models'
import { useAuth } from '../../../../auth'
import { Permission, SituacaoFatura } from '../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

export const FaturaAtendimentosTable = () => {
  const { t } = useT()
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { fatura, idEmpresa } = useFaturaAtual()
  const isResponsavel = !!idEmpresa
  const { currentUser } = useAuth()

  const isAdmin = currentUser?.grupo?.nome === Permission.Admin
  const podeEditar = fatura?.situacao === SituacaoFatura.Gerada

  const columns = useMemo(
    () => faturaAtendimentosColumns(t, { isAdmin, podeEditar, isResponsavel }),
    [t, isAdmin, podeEditar, isResponsavel]
  )

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum atendimento encontrado'
      description='Revise os filtros aplicados.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum atendimento nesta fatura'
      description='Os atendimentos faturados aparecem aqui.'
    />
  )

  return (
    <CustomTable<FaturaAtendimentoList>
      id='kt_table_fatura_atendimentos'
      ariaLabel={t('title.atendimentos_fatura')}
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
